import { render, staticRenderFns } from "./Produto.vue?vue&type=template&id=53bf181e&scoped=true&"
import script from "./Produto.vue?vue&type=script&lang=ts&"
export * from "./Produto.vue?vue&type=script&lang=ts&"
import style0 from "./Produto.vue?vue&type=style&index=0&id=53bf181e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bf181e",
  null
  
)

export default component.exports